import { render, staticRenderFns } from "./ProyectosForm.vue?vue&type=template&id=1ca10ef6"
import script from "./ProyectosForm.vue?vue&type=script&lang=js"
export * from "./ProyectosForm.vue?vue&type=script&lang=js"
import style0 from "./ProyectosForm.vue?vue&type=style&index=0&id=1ca10ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports